import { LoadIndexAbsoluteValues } from '../../_constants/load_value_absolute_values';

function getAbsoluteValueForLoadIndex(loadIndex) {
    return LoadIndexAbsoluteValues[loadIndex] || '';
}

export { getAbsoluteValueForLoadIndex };